// extracted by mini-css-extract-plugin
export default {"databases":"Databases_databases__2i0tZ"};